import { createContext, useContext } from 'react';
import { Fieldset, Grid } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export const TRANS_KEY = 'FORM_FIELDS.ADDRESS';
export const DEFAULT_SPAN = 6;

const DEFAULT_FIELD_PREFIX = 'address';

export const AddressPrefixContext = createContext<string>(DEFAULT_FIELD_PREFIX);

export const useAddressPrefix = (): string =>
  useContext(AddressPrefixContext) ?? DEFAULT_FIELD_PREFIX;

type RootProps = {
  children: React.ReactNode;
  fieldPrefix?: string;
  legend?: string;
};

export const Root: React.FC<RootProps> = ({
  children,
  fieldPrefix = DEFAULT_FIELD_PREFIX,
  legend,
}) => {
  const { t } = useTranslation();

  return (
    <AddressPrefixContext.Provider value={fieldPrefix}>
      <Fieldset legend={legend ?? t(`${TRANS_KEY}.ADDRESS_LABEL`)}>
        <Grid>{children}</Grid>
      </Fieldset>
    </AddressPrefixContext.Provider>
  );
};
